import { render } from "./ConfigurationBilling.vue?vue&type=template&id=be0be3a4&scoped=true"
import script from "./ConfigurationBilling.vue?vue&type=script&lang=js"
export * from "./ConfigurationBilling.vue?vue&type=script&lang=js"

import "./ConfigurationBilling.vue?vue&type=style&index=0&id=be0be3a4&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0be3a4"]])

export default __exports__